const forms = {
  onRequest: "A pedido", // translated
  person: "pessoa", // translated
  travelDate: "Data de viagem", // translated
  cancel: "Cancelar", // translated
  getPrice: "Obter preço", // translated
  travelDates: "Datas de viagem", // translated
};


export default forms;
